/**
 * Platform detection for the Capacitor native shell.
 *
 * Every native-only code path (Buy button external redirect, LPA scheme
 * install, biometric login, push notifications) checks `isNative()` first
 * so the web build stays byte-identical to what already ships on the site.
 */

import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();
export const platform = () => Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
export const isIOS = () => Capacitor.getPlatform() === 'ios';
export const isAndroid = () => Capacitor.getPlatform() === 'android';

/**
 * URL of the marketing website (used by the "reader app" checkout flow —
 * see `externalCheckout.js`). Defaults to production; can be overridden via
 * REACT_APP_WEB_URL env for staging builds.
 */
export const WEB_URL =
  (process.env.REACT_APP_WEB_URL || 'https://connectify-esims.com').replace(/\/+$/, '');
